<template>
  <div class="service-email-wrapper">
    <!-- <el-card>
      <z-search
        ref="searchArea"
        :showNumCheck="false"
        v-model="params"
        :configs="options['email']"
        @do-query="search"
        @do-reset="onReset"
      />
    </el-card> -->
    <emialBox ref="email" :params="params"></emialBox>
    <!-- <component :is="activeTab" :params="params" style="margin-top: 10px;" /> -->
  </div>
</template>
<script>
// import replied from './replied'
// import noplied from './noplied'
import emialBox from './email'
// import { getList } from '@/server/category.js'
export default {
  name: 'service-email',
  components: {
    emialBox
    // noplied,
    // replied
  },
  data() {
    return {
      params: {
        status: '',
        filterObj: '1',
        shopName: ''
      },
      activeTab: 'email',
      options: {
        email: [
          {
            key: 'shopId',
            label: '店铺',
            searchType: 'dict',
            componentData: {
              cache: false,
              dictKey: 'shop_id',
              placeholder: '请选择店铺',
              filterable: true,
              clearable: true
            }
          },
          {
            key: 'status',
            label: '状态',
            searchType: 'select',
            componentData: {
              options: [
                { label: '全部', value: '' },
                { label: '启用', value: '1' },
                { label: '停用', value: '0' }
              ],
              clearable: true
            }
          }
        ]
      }
    }
  },
  mounted() {
    if (this.$router.query && this.$router.query.name) {
      this.activeTab = this.$router.query.name
    }
  },
  methods: {
    async getEmail(resolve) {
      // const { data } = await getList({
      //   pageNum: 1,
      //   pageSize: 10
      // })
      // if (data.code === this.$code) {
      //   const datas = data.data.items.map((item, i) => {
      //     return {
      //       label: item.name,
      //       value: item.id
      //     }
      //   })
      //   return resolve(datas)
      // }
      // return resolve([])
    },
    onReset(params) {
      this.$refs[this.activeTab].initData(params)
    },
    search(params) {
      this.$refs[this.activeTab].search(params)
    }
  }
}
</script>
<style lang="scss" scoped></style>
